module.exports = __webpack_public_path__ + "static/insta-2d67e65c02336448c5eb75d7a0c26e98.png";